import { resolveFileUrl } from "./../../ricos-media/index.js";
import { AUDIO_TYPE, FILE_UPLOAD_TYPE, VIDEO_TYPE } from "./../../ricos-content/index.js";
const getVideoUrl = (src) => `https://video.wixstatic.com/${src.pathname}`;
const getThumbnailUrl = (src) => {
  if (src.pathname.startsWith("media/")) {
    return `https://static.wixstatic.com/${src.pathname}`;
  }
  return `https://static.wixstatic.com/media/${src.pathname}`;
};
const getAudioUrl = (src) => `https://static.wixstatic.com/${src.id}`;
function urlResolutionStrategy(hasPlugin, instance, metaSiteId, _experiments) {
  if (!metaSiteId) {
    return { config: {} };
  }
  return {
    config: {
      ...hasPlugin(VIDEO_TYPE) && {
        [VIDEO_TYPE]: {
          getVideoUrl,
          getThumbnailUrl
        }
      },
      ...hasPlugin(AUDIO_TYPE) && {
        [AUDIO_TYPE]: {
          getAudioUrl
        }
      },
      ...hasPlugin(FILE_UPLOAD_TYPE) && metaSiteId && {
        [FILE_UPLOAD_TYPE]: {
          resolveFileUrl: resolveFileUrl(metaSiteId, instance)
        }
      }
    },
    helpers: {
      getImageUrl({ file_name }) {
        return `https://static.wixstatic.com/media/${file_name}`;
      }
    }
  };
}
export {
  urlResolutionStrategy as default
};
//# sourceMappingURL=urlResolutionStrategy.js.map
